
import { useJsonData } from "../hooks/useJsonData";
import { FaInstagram, FaTiktok, FaFacebook, FaEnvelope, FaMapPin, FaPhone } from 'react-icons/fa';

const Footer = () => {
  const { data: websiteInfo } = useJsonData('info');

  return (
    <footer className="bg-black py-12">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-stretch flex-wrap gap-8">
          <div className="flex-1 min-w-[250px]">
            <h4 className="font-bold text-2xl pink-text uppercase font-oswald tracking-widest mb-4">Bando Collective</h4>
            <p className="text-white/80 font-sans">
              {websiteInfo?.description || "Kreativt kollektiv med fokus på konstnärligt uttryck och gemenskapsbyggande."}
            </p>
          </div>

          {websiteInfo?.contact && (
            <div className="flex-1 min-w-[250px]">
              <h4 className="font-bold text-2xl pink-text uppercase font-oswald tracking-widest mb-4">Kontakt</h4>
              <ul className="text-white/80 font-sans space-y-2">
                {websiteInfo?.location && (
                  <li className="flex items-center gap-2">
                    <FaMapPin size={16} />
                    <a 
                    href={`https://maps.google.com/?q=${websiteInfo?.location?.address}, ${websiteInfo?.location?.postalCode} ${websiteInfo?.location?.city}`}
                    className="hover:text-white transition-colors"
                    target="_blank" 
                    rel="noopener noreferrer"
                  >
                    {websiteInfo?.location?.address}, {websiteInfo?.location?.postalCode}{" "}
                    {websiteInfo?.location?.city}
                  </a>
                </li>
                )}
                {websiteInfo?.contact?.phone && (
                <li className="flex items-center gap-2">
                  <FaPhone size={16} />
                  <a 
                    href={`tel:${websiteInfo?.contact?.phone}`}
                    className="hover:text-white transition-colors"
                  >
                    {websiteInfo?.contact?.phone}
                  </a>
                </li>
                )}
                {websiteInfo?.contact?.email && (
                <li className="flex items-center gap-2">
                  <FaEnvelope size={16} />
                  <a 
                    href={`mailto:${websiteInfo?.contact?.email}`}
                    className="hover:text-white transition-colors"
                  >
                    {websiteInfo?.contact?.email}
                  </a>
                </li>
                )}
              </ul>
            </div>
          )}
          {websiteInfo?.social && (
          <div className="flex flex-col items-center md:items-end flex-1 min-w-[250px]">
            <h4 className="font-bold text-2xl pink-text uppercase font-oswald tracking-widest mb-4">Följ oss</h4>
            <div className="flex space-x-6">
              {websiteInfo?.social?.facebook && (
              <a 
                href={websiteInfo?.social?.facebook} 
                className="text-white hover:text-white/70 transition-colors cursor-pointer"
                target="_blank" 
                rel="noopener noreferrer"
                aria-label="Facebook"
              >
                <FaFacebook size={20} />
              </a>
              )}
              {websiteInfo?.social?.instagram && (
              <a 
                href={websiteInfo?.social?.instagram} 
                className="text-white hover:text-white/70 transition-colors cursor-pointer"
                target="_blank" 
                rel="noopener noreferrer"
                aria-label="Instagram"
              >
                <FaInstagram size={20} />
              </a>
              )}
              {websiteInfo?.social?.twitter && (
              <a 
                href={websiteInfo?.social?.twitter} 
                className="text-white hover:text-white/70 transition-colors cursor-pointer"
                target="_blank" 
                rel="noopener noreferrer"
                aria-label="Twitter"
              >
                <FaTiktok size={20} />
              </a>
              )}
              {websiteInfo?.social?.tiktok && (
              <a 
                href={websiteInfo?.social?.tiktok} 
                className="text-white hover:text-white/70 transition-colors cursor-pointer"
                target="_blank" 
                rel="noopener noreferrer"
                aria-label="TikTok"
              >
                <FaTiktok size={20} />
              </a>
              )}
            </div>
          </div>
          )}
        </div>

        <div className="mt-12 text-center">
          <p className="text-white/60 font-sans">
            &copy; {new Date().getFullYear()} Bando Collective. Alla rättigheter förbehållna.
          </p>
          <p className="text-white/60 font-sans mt-2">
            Built by <a href="https://coretechs.se" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">CoreTechs</a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
